import React from "react"
import EmptySearch from "@ui/icons/track/EmptySearch"
import {t} from "@ui/common/intl"

const EmptySearchResult = () => {
  return (
    <div className="empty-search-result">
      <EmptySearch/>
      <span>{t("search.empty.placeholder")}</span>
    </div>
  )
}

export default EmptySearchResult
